import { DiscountIssueTable } from '@/components/feature/DiscountIssuePage'
import { Container, Header, Title } from './styles'
import { useRecoilValue } from 'recoil'
import userAtom from '@/recoil/user'
import { validatePerm } from '@/libs/validatePermission'
import { BACKOFFICE_USER_PERMISSION } from '@/constant/BACKOFFICE_PERMISSION'
import UnauthorizedPage from '@/pages/Unauthorized'

function DiscountIssue() {
  const user = useRecoilValue(userAtom)

  return (
    <>
      {validatePerm([BACKOFFICE_USER_PERMISSION.DIS010101], user.permissions) ? (
        <Container>
          <Header>
            <Title>รายการส่วนลดที่มีปัญหา</Title>
          </Header>
          <DiscountIssueTable />
        </Container>
      ) : (
        <UnauthorizedPage />
      )}
    </>
  )
}

export default DiscountIssue
